export let config = {
	panel: [
		{
			id: 38,
			type: "solution",
			title: {
				en: "Turbocharger",
				de: "Turbocharger",
			},
			info: null,
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 3,
					type: "solution",
					title: {
						en: "Dry and Wet Cleaning for Turbocharger",
						de: "Dry and Wet Cleaning for Turbocharger",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/Dry_and_wet_cleaning.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"Regular and proper turbocharger maintenance ensures peak performance, extends the time between overhauls, and maintains fuel efficiency – neglect can lead to a 5% increase in fuel consumption.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 39,
					type: "solution",
					title: {
						en: "Damping Elements",
						de: "Damping Elements",
					},
					info: "Applicable for Everllence TCA55, 66, 77 & 88",
					image:
						"/apps/configurators/shared/assets/images/content/tc-damping-elements.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Benefits of damping elements: <ul><li>Up to 30% higher resistance against HCF</li><li>More reliable product providing a higher operational safety margin</li><li>Higher robustness of TCA turbine rotor</li><li>Easy implementation during maintenance</li><li>Damage prevention and cost minimization</li></ul>",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 40,
			type: "solution",
			title: {
				en: "Cylinder head",
				de: "Cylinder head",
			},
			info: null,
			image: null,
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 7,
					type: "solution",
					title: {
						en: "New Valve Seat Sealing-Ring",
						de: "New Valve Seat Sealing-Ring",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/New_valve_and_sealing_ring.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"The New Valve Seat Sealing-Ring for Everllence 51/60DF engines is designed for enhanced valve sealing within the cylinder cover. This innovative upgrade ensures improved reliability and availability by offering superior sealing performance, which is crucial for maintaining engine integrity and efficiency.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 41,
			type: "solution",
			title: {
				en: "Fuel Injection system",
				de: "Fuel Injection system",
			},
			info: null,
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 8,
					type: "solution",
					title: {
						en: "MK3 Injection Pump Upgrade",
						de: "MK3 Injection Pump Upgrade",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/mk3.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"Elevate your Everllence 51/60DF engine with the MK3 Injection Pump Upgrade, engineered for superior performance. This new pump generation provides significantly increased reliability and more than doubles the operating time between engine overhauls. Main benefits: Easy to upgrade, significant reduction of sticking plungers, leakage reuse, state-of-art manufacturing.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "/apps/configurators/shared/assets/pdfs/evr-mk3-pump_ps_factsheet_l3_2505.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 42,
			type: "solution",
			title: {
				en: "Automation & engine control system",
				de: "Automation & engine control system",
			},
			info: null,
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 9,
					type: "solution",
					title: {
						en: "VIT - Variable Injection Timing",
						de: "VIT - Variable Injection Timing",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/PrimeServ_Reckrod.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"The VIT product is a reliable solution for easy retrofitting to enhance engine reliability. This solution shifts to a four-injection-timing configuration, optimizing fuel use between 50% and 65% MCR and ensuring robust engine performance with the safety of SaCoS control.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 14,
					type: "solution",
					title: {
						en: "Electronic Checkup",
						de: "Electronic Checkup",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/PrimeServ_Reckrod-single.jpg",
					categories: [
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Ensure your Everllence 51/60DF engine's peak performance with our Electronic Checkup. Conducted by our Superintendent Engineer, this service thoroughly assesses and optimizes engine functionality, focusing on efficiency, reliability, and cost-effective operation tailored to your engine's specific needs.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 16,
					type: "solution",
					title: {
						en: "Fuel Adaption Control (FAC)",
						de: "Fuel Adaption Control (FAC)",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/Everllence_L21-31DF-M_Gorm-Branderup0012.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"The Fuel Adaptation Control (FAC) enhances engine safety and reliability for SaCoS one and other governor controllers. It adjusts smoothly across different fuel types, reducing leakage, fuel variability and component wear issues, thus improving engine efficiency, availability, and cost savings.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 17,
					type: "solution",
					title: {
						en: "Cylinder Pressure Monitoring (CyPreMo)",
						de: "Cylinder Pressure Monitoring (CyPreMo)",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/CyPreMo.jpg",
					categories: [
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"CyPreMo, our field product performance monitoring system, is a constant cylinder pressure monitor on the engine. It elevates engine wear analysis and fuel quality evaluation, boosting efficiency, reliability, and cost savings, thus protecting engine performance and improving longevity.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 18,
					type: "solution",
					title: {
						en: "Oil Mist Detector",
						de: "Oil Mist Detector",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/PrimeServ_Reckrod-single.jpg",
					categories: [
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Enhance the safety of your Everllence 51/60DF engines with our Oil Mist Detector. This essential device continuously monitors crankcase oil mist to prevent significant damages, support engine efficiency, availability, reliability, and reduce maintenance costs. It is an indispensable tool for proactive engine management.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 48,
					type: "solution",
					title: {
						en: "MMS for safety",
						de: "MMS for safety",
					},
					info: "Applicable for all Everllence 51/60DF engine types",
					image: "/apps/configurators/shared/assets/images/content/MMS.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"As a complement to Multifunction Monitoring System, MMS for safety provides three optional specific modules that ensure the management of main engine safeties while the engine operation: crank pins lube oil temperature monitoring for crankshaft protection; main bearing monitoring for bearing protection and pressure monitoring for crankcase protection.<br><br>Sensors detect over deviation and active alarm or immediate stop order. That’s an additional range of modules to Multifunction Monitoring System. Modules are activated according to the operator’s needs.<br><br>The material is safety qualified for engine stops for marine applications: CE, BV, DNV, DNV-GL, GL, RS, LR, RINA, ABS, RMRS, CCS, KR, NK.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "More about MMS for safety",
								de: "More about MMS for safety",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multifunction-monitoring-systems",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 49,
					type: "solution",
					title: {
						en: "Multifunction Monitoring System (MMS)",
						de: "Multifunction Monitoring System (MMS)",
					},
					info: "Applicable for all Everllence 51/60DF engine types",
					image: "/apps/configurators/shared/assets/images/content/MMS.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Multifunction Monitoring System provides in a unique panel, the monitoring management system of the crucial operating data of the running engine and its auxiliaries.<br><br>Thanks to six complementary sources of data, MMS monitors the health and the behavior of the engine and its auxiliaries that are experiencing high strain and are central for global engine efficiency.<br><ul><li>Compliance: CE, Bureau Veritas, DNV, GL, KR, CCS, ABS, RINA</li></ul>",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "More about Multifunction Monitoring System",
								de: "More about Multifunction Monitoring System",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multifunction-monitoring-systems",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 50,
					type: "solution",
					title: {
						en: "MFM for lube oil (Multi Fluid Monitor)",
						de: "MFM for lube oil (Multi Fluid Monitor)",
					},
					info: "Applicable for all Everllence 51/60DF engine types",
					image: "/apps/configurators/shared/assets/images/content/MFM.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Everllence Multi Fluid Monitor for lube oil constantly monitors the lube oil. Using truly autonomous intelligence, it analyses the lube oil, detects anomalies and alerts the operator of any deviations. It provides a global view of all the operational lube oil parameters.<br><br>The solution is integrated into the main lube oil system of the equipment.<br><br>All types of four-stroke engines and two-stroke engines (system oil only) – Everllence and other brands, engine auxiliaries.<br><br>Everllence Multi Fluid Monitor for lube oil meets CE standards, has the following certifications:<ul><li>Marine: BV, ABS</li><li>Navy: NNO6630145997886, IEC shocks standards</li><li>Cyber Security: BV IACS UR E27</li></ul>",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "More about Multi Fluid Monitor",
								de: "More about Multi Fluid Monitor",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/multi-fluid-monitor",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 43,
			type: "solution",
			title: {
				en: "Operation & Performance",
				de: "Operation & Performance",
			},
			info: null,
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 11,
					type: "solution",
					title: {
						en: "Engine Part Load Optimization (EPLO)",
						de: "Engine Part Load Optimization (EPLO)",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/EPLO.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Maximize Everllence 51/60DF engine performance with Engine Part Load Optimization (EPLO), including a VIT Replacement kit. It boosts efficiency at part load, aligning output with demand for fuel savings, reliability, and lower costs, positively impacting your CII rating and CO₂ emissions.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 19,
					type: "solution",
					title: {
						en: "SCR Customized Retrofit",
						de: "SCR Customized Retrofit",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/scr_retrofit.jpg",
					categories: [
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"With the SCR Customized Retrofit for Everllence 51/60DF engines, you can achieve Tier 3 NOₓ compliance. This retrofit significantly lowers NOₓ emissions by up to 95%, adapts to various operational needs and regulations, and ensures environmental adherence and operational efficiency.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 21,
					type: "solution",
					title: {
						en: "Low Sulphur Fuel Upgrade",
						de: "Low Sulphur Fuel Upgrade",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/Low_sulphur_operation_package.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"The Low Sulphur Fuel Upgrade for all 51/60DF engines ensures SOₓ compliance, enhancing fuel adaptability with minimal lubricity and viscosity issues. It extends engine life, maintains low-sulfur fuel performance, and significantly reduces fuel-induced contamination, optimizing operations in regulated zones.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 31,
			type: "service",
			title: {
				en: "PrimeServ Assist",
				de: "PrimeServ Assist",
			},
			info: null,
			image:
				"/apps/configurators/shared/assets/images/content/PrimeServ_Assist.jpg",
			categories: [
				{
					en: "Efficiency",
					de: "Wirkungsgrad",
				},
				{
					en: "Availability",
					de: "Verfügbarkeit",
				},
				{
					en: "Cost Reduction",
					de: "Kostenreduzierung",
				},
				{
					en: "Emission Reduction",
					de: "Emissionsreduzierung",
				},
			],
			engines: [],
			description:
				"PrimeServ Assist, powered by Everllence CEON, is a proactive service that identifies anomalies and provides essential operational and maintenance insights. It helps reduce operational expenses and increase uptime, making maintenance planning more predictable. Precise data informs you early about potential issues.",
			links: [
				{
					text: {
						en: "Contact us for tailored solutions",
						de: "Kontaktiere uns",
					},
					mode: "fill",
					url: "#contact",
					type: "",
				},
				{
					text: {
						en: "Download Brochure",
						de: "Download Brochure",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/primeserv-assist#download",
					mode: "",
					type: "external",
				},
				{
					text: {
						en: "Explore PrimeServ Assist",
						de: "Explore PrimeServ Assist",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/digital-solutions/primeserv-assist",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 33,
			type: "service",
			title: {
				en: "Original Spare Parts",
				de: "Original Spare Parts",
			},
			info: null,
			image: "/apps/configurators/shared/assets/images/content/Spare_parts.jpg",
			categories: [
				{
					en: "Efficiency",
					de: "Wirkungsgrad",
				},
				{
					en: "Availability",
					de: "Verfügbarkeit",
				},
				{
					en: "Cost Reduction",
					de: "Kostenreduzierung",
				},
			],
			engines: [],
			description:
				"Ensure peak performance for your Everllence 51/60DF engines with Original Spare Parts by Everllence Energy Solutions. These spare parts protect your investment while enhancing efficiency. Opt for safety and precision with original parts. For tailored assistance, reach out to our Service experts.",
			links: [
				{
					text: {
						en: "Contact us for tailor-made solutions",
						de: "Kontakt aufnehmen",
					},
					mode: "fill",
					url: "#contact",
					type: "",
				},
				{
					text: {
						en: "Get the Spare Parts Brochure",
						de: "Get the Spare Parts Brochure",
					},
					url: "https://www.everllence.com/docs/default-source/services-factsheets/145879-everllence-spare-parts-essentials-brochure-5.pdf?sfvrsn=8b291f61_3",
					mode: "",
					type: "external",
				},
				{
					text: {
						en: "Explore Spare Parts",
						de: "Explore Spare Parts",
					},
					url: "https://www.everllence.com/services/offerings/marine-power/spare-parts",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 34,
			type: "service",
			title: {
				en: "Everllence PrimeServ Academies",
				de: "Everllence PrimeServ Academies",
			},
			info: null,
			image: "/apps/configurators/shared/assets/images/content/Academies.jpg",
			categories: [
				{
					en: "Efficiency",
					de: "Wirkungsgrad",
				},
				{
					en: "Availability",
					de: "Verfügbarkeit",
				},
				{
					en: "Reliability",
					de: "Verlässlichkeit",
				},
				{
					en: "Cost Reduction",
					de: "Kostenreduzierung",
				},
			],
			engines: [],
			description:
				"Explore our premium training solutions tailored for Everllence 51/60DF engines, offering a perfect blend of theoretical knowledge and practical skills. Each business is unique, and we accommodate your specific requirements. Connect with our Everllence PrimeServ Academies experts to select the ideal course for your needs.",
			links: [
				{
					text: {
						en: "Contact our Academy experts",
						de: "Kontaktiere uns",
					},
					mode: "fill",
					url: "#contact",
					type: "",
				},
				{
					text: {
						en: "Explore PrimeServ Academies",
						de: "Explore PrimeServ Academies",
					},
					url: "https://www.everllence.com/services/primeserv-academy",
					mode: "",
					type: "external",
				},
			],
			children: [],
		},
		{
			id: 44,
			type: "service",
			title: {
				en: "Maintenance & Service Agreements",
				de: "Maintenance & Service Agreements",
			},
			info: null,
			image: "",
			engines: [],
			categories: ["", "", "", "", ""],
			description: "",
			links: [],
			children: [
				{
					id: 22,
					type: "service",
					title: {
						en: "LTSA - Standard Maintenance Agreement (SMA)",
						de: "LTSA - Standard Maintenance Agreement (SMA)",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/LTSA.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Long-term service agreements by Everllence PrimeServ are peace-of-mind solutions. The Standard Maintenance Agreement for Everllence 51/60DF engines minimizes downtime and operational costs through proactive maintenance. We tailor service agreements to help you optimize the operational cost and budget reliability of preventive and conditioned-based maintenance. Get access to our Service experts at all times.",
					links: [
						{
							text: {
								en: "Contact us for tailored agreement",
								de: "Kontaktiere uns",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Get the LTSA Brochure",
								de: "Get the LTSA Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about LTSA for your engines",
								de: "More about LTSA for your engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 23,
					type: "service",
					title: {
						en: "LTSA - Spare Parts Agreement (SPA)",
						de: "LTSA - Spare Parts Agreement (SPA)",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/LTSA.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Long-term service agreements by Everllence PrimeServ are peace-of-mind solutions. LTSA – Spare Parts Agreement for Everllence 51/60DF engines ensures timely spare part deliveries for scheduled maintenance. This first level of LTSA provides preferred pricing, reduced admin effort, and MAN's on-time delivery commitment, enhancing operational efficiency and reliability.",
					links: [
						{
							text: {
								en: "Contact us for tailored agreement",
								de: "Kontaktiere uns",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Get the LTSA Brochure",
								de: "Get the LTSA Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about LTSA for your engines",
								de: "More about LTSA for your engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 24,
					type: "service",
					title: {
						en: "LTSA - Condition Assessment (CA) Options",
						de: "LTSA - Condition Assessment (CA) Options",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/LTSA.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Long-term service agreements by Everllence PrimeServ are peace-of-mind solutions. Optimize maintenance with LTSA – Condition Assessment Options for Everllence 51/60DF engines, featuring diagnostic tools and remote monitoring by Everllence specialist. This approach ensures early detection for proactive maintenance and quick troubleshooting, minimizing downtime.",
					links: [
						{
							text: {
								en: "Contact us for tailored agreement",
								de: "Kontaktiere uns",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Get the LTSA Brochure",
								de: "Get the LTSA Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about LTSA for your engines",
								de: "More about LTSA for your engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 25,
					type: "service",
					title: {
						en: "LTSA - Uptime Optimization (UO) Options",
						de: "LTSA - Uptime Optimization (UO) Options",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/LTSA.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"Long-term service agreements by Everllence PrimeServ are peace-of-mind solutions. LTSA – Uptime Optimization (UO) Options for Everllence 51/60DF engines enhance uptime, offering rapid maintenance and fast response to unplanned events. Benefits include reduced downtime, strategic spare part pricing, Everllence maintenance crews, and guaranteed response times in case of emergencies.",
					links: [
						{
							text: {
								en: "Contact us for tailored agreement",
								de: "Kontaktiere uns",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Get the LTSA Brochure",
								de: "Get the LTSA Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/services-factsheets/everllence-ltsa-service-agreements_brochure_final.pdf?sfvrsn=66d48de7_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about LTSA for your engines",
								de: "More about LTSA for your engines",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/service-agreements",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 26,
					type: "service",
					title: {
						en: "Maintenance interval (TBO extension)",
						de: "Maintenance interval (TBO extension)",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/LTSA.jpg",
					categories: [
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"Maximize operational efficiency with our TBO extension for Everllence 51/60DF engines. This solution significantly reduces long-term operational costs and extends maintenance intervals, ensuring your engines to perform optimally longer.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "More about TBO Extension",
								de: "More about TBO Extension",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/tbo-extension",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 45,
			type: "service",
			title: {
				en: "Operation Agreements",
				de: "Operation Agreements",
			},
			info: null,
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 28,
					type: "service",
					title: {
						en: "O&M - Full Operation and Maintenance Agreement",
						de: "O&M - Full Operation and Maintenance Agreement",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/o_m.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"The Full Operation & Maintenance Agreement offers a turnkey solution for managing and maintaining your power plant facilities. This comprehensive service ensures the 24/7 operation of your facility with proven practices and global support, optimizing performance and reliability.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 29,
					type: "service",
					title: {
						en: "O&M Management Agreement",
						de: "O&M Management Agreement",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/o_m.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"The O&M Management Agreement places Everllence PrimeServ O&M specialists within your team for complete power plant management. It encompasses staffing, setups, and maintenance systems. Benefit from comprehensive facility management, mentoring, and spare parts supply, all aimed at boosting plant performance and efficiency.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 30,
					type: "service",
					title: {
						en: "O&M Support Agreement",
						de: "O&M Support Agreement",
					},
					info: null,
					image: "/apps/configurators/shared/assets/images/content/o_m.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Emission Reduction",
							de: "Emissionsreduzierung",
						},
					],
					engines: [1],
					description:
						"The O&M Support Agreement enhances power plant operations with Everllence PrimeServ O&M's expert management, maintenance, and operations guidance. This service ensures contractual compliance and offers additional benefits such as OEM spare parts management, on-site professional support, and mentoring.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 32,
			type: "service",
			title: {
				en: "Fluid Monitor",
				de: "Fluid Monitor",
			},
			info: null,
			image: null,
			categories: [],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 321,
					type: "service",
					title: {
						en: "PrimeServ Lab",
						de: "PrimeServ Lab",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/PrimeServ_Lab.jpg",
					categories: [
						{
							en: "Efficiency",
							de: "Wirkungsgrad",
						},
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"Analyze all your engine fluids to optimize operation and prevent damage with our PrimeServ Lab. It quickly delivers expert analysis and actionable insights. This solution is part of proactive maintenance and enhances engine performance and reliability, and thus reduces costs.",
					links: [
						{
							text: {
								en: "Contact us for tailored solutions",
								de: "Kontaktiere uns",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/primeserv/evr_primeserv_lab_brochure_2505_final_preview.pdf?sfvrsn=bb7a457d_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about PrimeServ Lab",
								de: "More about PrimeServ Lab",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/primeserv-lab",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 40,
					type: "service",
					title: {
						en: "Everllence Fluid Monitor",
						de: "Everllence Fluid Monitor",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/fluid_monitor.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						'With several monitoring features, as well as sensors and algorithms, Everllence Fluid Monitor ensures continuous condition-based monitoring of the engine\'s lubricating oil. With "stop engine" possibilities, alerts, and trouble-shooting recommendations, you can anticipate necessary actions before failures happen.',
					links: [
						{
							text: {
								en: "Contact us",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
						{
							text: {
								en: "Download Brochure",
								de: "Download Brochure",
							},
							url: "https://www.everllence.com/docs/default-source/primeserv/evr_primeserv_lab_brochure_2505_final_preview.pdf?sfvrsn=bb7a457d_3",
							mode: "",
							type: "external",
						},
						{
							text: {
								en: "More about Engine fluid monitoring service",
								de: "More about Engine fluid monitoring service",
							},
							url: "https://www.everllence.com/services/offerings/marine-power/primeserv-lab/engine-fluid-monitoring-service",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 46,
			type: "service",
			title: {
				en: "Maintenance",
				de: "Maintenance",
			},
			info: null,
			image: "",
			categories: ["", "", "", "", ""],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 35,
					type: "service",
					title: {
						en: "Tools on Loan",
						de: "Tools on Loan",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/PrimeServ_Reckrod-single.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
					],
					engines: [1],
					description:
						"Enhance maintenance safety for Everllence 51/60DF engines with Tools on Loan from Everllence PrimeServ. Rent the precise tools needed for efficient repairs, ensuring reliability and availability without the overhead of ownership. This service streamlines the maintenance process, safeguarding both performance and personnel.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
				{
					id: 36,
					type: "service",
					title: {
						en: "New Tools Update",
						de: "New Tools Update",
					},
					info: null,
					image:
						"/apps/configurators/shared/assets/images/content/PrimeServ_Shanghai.jpg",
					categories: [
						{
							en: "Availability",
							de: "Verfügbarkeit",
						},
						{
							en: "Reliability",
							de: "Verlässlichkeit",
						},
						{
							en: "Cost Reduction",
							de: "Kostenreduzierung",
						},
					],
					engines: [1],
					description:
						"The New Tools Update for Everllence 51/60DF engines introduces a modified maintenance tool to enhance operational efficiency. Preventing stud breakage saves working hours and reduces cost while improving engine availability and reliability.",
					links: [
						{
							text: {
								en: "Contact us for tailor-made solutions",
								de: "Kontakt aufnehmen",
							},
							mode: "fill",
							url: "#contact",
							type: "",
						},
					],
				},
			],
		},
	],
	pluses: [
		// Parent ID for typeItemId
		{
			id: 1,
			x: 33,
			y: 20,
			text: "Turbocharger",
			typeItemId: 38,
			type: "solution",
			direction: "right",
		},
		{
			id: 2,
			x: 48,
			y: 26,
			text: "Cylinder head",
			typeItemId: 40,
			type: "solution",
			direction: "right",
		},
		{
			id: 3,
			x: 53,
			y: 36.5,
			text: "Fuel injection system",
			typeItemId: 41,
			type: "solution",
			direction: "right",
		},
		{
			id: 5,
			x: 32.8,
			y: 45.3,
			text: "Automation & engine control system",
			typeItemId: 42,
			type: "solution",
			direction: "right",
		},
		{
			id: 6,
			x: 85,
			y: 56,
			text: "Operation Agreements",
			typeItemId: 45,
			type: "service",
			direction: "left",
		},
		{
			id: 7,
			x: 87,
			y: 73,
			text: "Maintenance & Service Agreements",
			typeItemId: 44,
			type: "service",
			direction: "left",
		},
		{
			id: 8,
			x: 75,
			y: 80.5,
			text: "Operation & Performance",
			typeItemId: 43,
			type: "solution",
			direction: "left",
		},
		{
			id: 9,
			x: 13,
			y: 75.5,
			text: "PrimeServ Assist",
			typeItemId: 31,
			type: "service",
			direction: "right",
		},
		{
			id: 12,
			x: 27,
			y: 81,
			text: "Fluid Monitor",
			typeItemId: 32,
			type: "service",
			direction: "right",
		},
		{
			id: 10,
			x: 42,
			y: 84,
			text: "Original Spare Parts",
			typeItemId: 33,
			type: "service",
			direction: "right",
		},
		{
			id: 11,
			x: 58,
			y: 83.5,
			text: "Everllence PrimeServ Academies",
			typeItemId: 34,
			type: "service",
			direction: "right",
		},
		{
			id: 39,
			x: 41,
			y: 21,
			text: "Damping Elements",
			typeItemId: 38,
			type: "service",
			direction: "right",
		},
	],
	engines: [
		{
			id: 1,
			type: null,
			image:
				"/apps/configurators/engine-51-60-df/assets/images/engine-51-60.png",
			text: {
				en: "51/60-DF",
				de: "51/60-DF",
			},
		},
	],
	navigation: [
		{
			key: "solution",
			title: {
				en: "Solutions",
				de: "Solutions",
			},
			panelItems: [38, 40, 41, 42, 43],
		},
		{
			key: "service",
			title: {
				en: "Services",
				de: "Services",
			},
			panelItems: [31, 33, 34, 44, 45, 32],
		},
	],
};
